import columnGenerator from 'components/DataGridCustom/ColumnGenerator';
import DataGridCustom from 'components/DataGridCustom/DataGridCustom';
import { useTranslation } from 'react-i18next';
import MeasurementStatistic from 'models/MeasurementStatistic';
import moment from 'moment';

function Chronicles({
  measurements,
  loading = false,
  totalElements,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  sortModel,
  onSortModelChange,
}: {
  measurements: MeasurementStatistic[];
  loading?: boolean;
  totalElements?: number;
  page?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  sortModel?: any;
  onSortModelChange?: (model: any) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const columns = [
    // colonnes calculées côté front : aucun champ Mongo correspondant, donc pas de tri serveur possible
    { ...columnGenerator('measurement', 'deviceName'), sortable: false },
    { ...columnGenerator('measurement', 'measurer'), sortable: false },
    {
      ...columnGenerator('measurement', 'measurementDate'),
      type: 'dateTime',
      valueGetter: (params: any) =>
        params?.value ? new Date(params.value) : null,
      valueFormatter: (params: any) =>
        moment.utc(params?.value).local().format('DD/MM/YYYY HH:mm'),
    },
    { ...columnGenerator('measurement', 'measurerValue'), type: 'number' },
  ];

  return (
    <DataGridCustom
      columns={columns}
      rows={measurements || []}
      loading={loading}
      noDataText={t('measurement.noChronicles')!}
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      rowCount={totalElements}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      getRowId={(row: any) => row.rowId}
    />
  );
}

export default Chronicles;
